<template lang="pug">
.form-wrapper
  form(action='#'
       :endpoint='endpoint'
       :no-submit='$attrs["no-submit"]'
       v-on:submit.prevent='submitForm(endpoint)'
  )
    h4(v-if='formHeader') {{formHeader}}
    slot
    ed-button(v-if='submitVisible', :class='submitClass', type='submit') {{ submitText }}
</template>

<script>

export default {
  name: 'ed-form',
  props: {
    formHeader: String,
    submitClass: {
      type: String,
      default: 'btn btn-primary'
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    submitVisible: {
      type: Boolean,
      default: true
    },
    endpoint: String
  },
  methods: {
    submitForm: (endpoint) => {
      this.api.forms.post(endpoint /*, data */)
        .then((res) => {
        })
        .catch((err) => console.error(err))
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

body .theme .form-wrapper .form-group {
  margin-bottom: 15px;
}
body .theme .form-wrapper .table .form-group {
  margin-bottom: 0;
}

.table {
  border-collapse: inherit;
}
.table td {
  @include theme {
  background: v(canvas);
  }
}

form.invalid {
  .table {
    //@include theme {
    //border: 2px solid v(urgent-01);
    //}
    tr.required td {
      @include theme {
      background: v(attention-03);
      }
    }
  }
  &.validate {
    .form-control {
      @include theme {
      border: 2px solid v(urgent-01);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edForm/index.vue